import {heIL} from "./heIL";
import {MDText} from "i18n-react/dist/i18n-react";

export const i18n = new MDText(heIL)